<swiper
  [spaceBetween]="5"
  [thumbs]="{ swiper: thumbsSwiper }"
  class="auction-swiper2"
>
  <ng-template swiperSlide *ngFor="let slide of slides; index as i">
    <img [src]="slide" alt="{{ i }}" />
  </ng-template>
</swiper>

<div class="swiper-secondary-wrapper">
  <swiper
    #swiperSecondary
    (swiper)="thumbsSwiper = $event"
    [virtual]="true"
    [spaceBetween]="5"
    [slidesPerView]="6"
    [freeMode]="true"
    [watchSlidesProgress]="true"
    class="auction-swiper"
  >
    <ng-template swiperSlide *ngFor="let slide of slides; index as i">
      <img [src]="slide" alt="{{ i }}" />
    </ng-template>
  </swiper>

  <button
    type="button"
    class="swiper-nav swiper-nav__prev"
    (click)="slidePrev()"
  >
    <ion-icon name="caret-back-sharp"></ion-icon>
  </button>
  <button
    type="button"
    class="swiper-nav swiper-nav__next"
    (click)="slideNext()"
  >
    <ion-icon name="caret-forward-sharp"></ion-icon>
  </button>
</div>
